<!-- routify:options title='Dealers' -->
<!-- routify:options index=1 -->
<!-- routify:options showInNavigation=true -->

<script>
    import { fetchJSON } from '../../../common/Backend'
    import { scrollToTop } from '../../../common/Utils'
    import { t } from 'totalinvoice-frontend-core'
    import { Button, Notification, ServerErrorNotification }  from 'totalinvoice-frontend-core'
    import { STATUS_NONE, STATUS_PROCESSING, STATUS_SUCCESS, STATUS_SERVER_ERROR } from 'totalinvoice-frontend-core'

    let status = STATUS_NONE

    let error = ''
    let showServerErrorNotification = false
    $: showServerErrorNotification = status === STATUS_SERVER_ERROR

    let user = ''
    let showSuccessNotification = false
    $: showSuccessNotification = status === STATUS_SUCCESS

    const dealer = {
        firstName: '',
        lastName: '',
        email: '',
        emailVerified: false,
        dealerId: '',
    }

    async function create() {
        status = STATUS_PROCESSING
        const res = await fetchJSON("dealer/add", { ...dealer })
        if (res.status === 'ok') {
            status = STATUS_SUCCESS
            user = res.data
        } else {
            status = STATUS_SERVER_ERROR
            error = res
        }
        scrollToTop()
    }
</script>

<h2 class="title is-2 is-spaced page-title">{$t('Create Dealer Account')}</h2>

{#if showServerErrorNotification}
    <ServerErrorNotification bind:active={showServerErrorNotification} {error} />
{/if}

{#if showSuccessNotification}
    <Notification type='is-success' bind:active={showSuccessNotification} icon={true}>
        <strong>{$t('Dealer created successfully.')}<br></strong>
        <div class="mt-3">
            {$t('User ID')}: {user.userId}<br>
            {$t('E-mail')}: {user.email} ({user.emailVerified ? $t('verified') : $t('not verified')})<br>
            {$t('Password')}: {user.password}
        </div>
    </Notification>
{/if}

<div class="field is-horizontal">
    <div class="field-label is-normal">
        <label for class="label">{$t('Name')}</label>
    </div>
    <div class="field-body">
        <div class="field">
            <p class="control is-expanded">
                <input class="input" type="text" bind:value={dealer.firstName}>
            </p>
            <p class="help">{$t('First name')}</p>
        </div>
        <div class="field">
            <p class="control is-expanded">
                <input class="input" type="text" bind:value={dealer.lastName}>
            </p>
            <p class="help">{$t('Last name')}</p>
        </div>
    </div>
</div>

<div class="field is-horizontal">
    <div class="field-label is-normal">
        <label for class="label">{$t('E-mail')}</label>
    </div>
    <div class="field-body">
        <div class="field">
            <p class="control is-expanded">
                <input class="input" type="email" bind:value={dealer.email}>
            </p>
            <p class="help">{$t('E-mail')}</p>
        </div>
    </div>
</div>
<div class="field is-horizontal">
    <div class="field-label is-normal"></div>
    <div class="field-body">
        <div clas="field">
            <p class="control is-expanded">
                <input type="checkbox" bind:checked={dealer.emailVerified}> {$t('E-mail is verified')}
            </p>
        </div>
    </div>
</div>

<div class="field is-horizontal">
    <div class="field-label is-normal">
        <label for class="label">{$t('Dealer ID')}</label>
    </div>
    <div class="field-body">
        <div class="field">
            <p class="control is-expanded">
                <input class="input" type="number" bind:value={dealer.dealerId}>
            </p>
            <p class="help">{$t('Use 0 for a TotalEnergies dealer')}</p>
        </div>
    </div>
</div>

<div class="field is-horizontal">
    <div class="field-label"></div>
    <div class="field-body">
        <div class="field">
            <div class="control">
                <Button type='is-link'
                        loading={status === STATUS_PROCESSING}
                        on:click={create}>
                    {$t('Create')}
                </Button>
            </div>
        </div>
    </div>
</div>
